import React from "react";
import { Link } from "react-router-dom";
import "./Officecleanoutsheader.css";

export default function Officecleanoutsheader() {
  const base = process.env.PUBLIC_URL;

  return (
    <section
      className="oc-hero"
      role="banner"
      aria-label="Office Cleanouts hero banner"
    >
      {/* Background image (full width) */}
      <img
        className="oc-hero__bg"
        src={`${base}/(232).webp`}
        alt="Professional office cleanout team at work"
        loading="eager"
      />

      {/* Gradient/dimming overlay */}
      <div className="oc-hero__overlay" aria-hidden="true" />

      {/* Centered content */}
      <div className="oc-hero__content">
        <nav className="oc-hero__breadcrumb" aria-label="Breadcrumb">
          <Link to="/" className="oc-hero__breadcrumb-link">Home</Link>
          <span className="oc-hero__breadcrumb-sep" aria-hidden="true">›</span>
          <span className="oc-hero__breadcrumb-current">YardDebris Removal</span>
        </nav>

        <h1 className="oc-hero__title">YardDebris Removal</h1>
        <p className="oc-hero__subtitle">
          Professional office space clearing services for a fresh start.
        </p>
      </div>

      {/* Premium depth touches */}
      <div className="oc-hero__vignette" aria-hidden="true" />
      <div className="oc-hero__grain" aria-hidden="true" />
    </section>
  );
}
